import React from "react";
import {ResultsView} from "./ResultsView";
import {loadTodayStats} from "../services/historyService";
import {GEAR_COUNT} from "./GearsScoreboard";

/** The /result route: shows today's stored result from localStorage. */
export const ResultScreen = () => {
    const stats = loadTodayStats();

    return (
        <div className={"container flex-wrapper"}>
            <ResultsView scoreBoard={stats.scoreBoard ?? []}
                         total={stats.scoreBoard?.length ?? GEAR_COUNT}
                         lapsToday={stats.lapsToday}
                         daysInARow={stats.daysInARow}
                         playedToday={stats.playedToday}/>
        </div>
    );
};
